import { type ReactNode } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { LoadingSpinner } from '../common/LoadingSpinner'

interface RequireFullSalonAdminProps {
  children: ReactNode
}

/** Alleen volledige salon-admin (of superadmin); anders doorverwijzen naar agenda. */
export function RequireFullSalonAdmin ({ children }: RequireFullSalonAdminProps) {
  const { salonId } = useParams<{ salonId: string }>()
  const { loading, profileLoading, isSuperadmin, isFullSalonAdmin } = useAuth()

  if (loading || profileLoading) return <LoadingSpinner />
  if (!salonId) return <Navigate to="/login" replace />
  if (isSuperadmin || isFullSalonAdmin(salonId)) return <>{children}</>

  return <Navigate to={`/login/${salonId}/agenda-v2`} replace />
}
